/* Ability Warehouse — instant variant switching extras (product pages with variants).
   On every variant change (event 'aw:variant' from variant-picker.js), with no page load:
   - the heading, browser tab title and breadcrumb read "Product – Red" (the chosen variant);
   - the gallery jumps to that variant's photo;
   Variant photos are loaded in the background after the page settles, and a swatch's photo is warmed on hover,
   so switching never waits on an image. Opening a ?variant= link shows that variant's title straight away.
   v40: when the variant's photo is not one of the gallery slides (the gallery shows the first 12 photos), the first
   slide's photo is swapped to the variant's photo and the gallery scrolls back to it; the sticky bar title follows too. */
(function () {
  'use strict';
  var box = document.querySelector('[data-variant-picker]');
  if (!box) return;
  var product;
  try { product = JSON.parse(box.querySelector('[data-vp-product]').textContent); } catch (e) { return; }
  if (!product || !product.variants || product.variants.length < 2) return;

  var h1 = document.querySelector('.pdp-title, h1.product__title');
  var sbTitle = document.querySelector('.sticky-buy__title');
  var crumb = document.querySelector('.crumbs [aria-current="page"]');
  var base = product.title;
  var docBase = document.title;

  /* "Red", "Size 3", "Red, Size 3": colour values on their own, other options with their name when the value is short or a number */
  function vTitle(v) {
    return (v.options || [v.title]).map(function (val, i) {
      var name = String((product.options || [])[i] || '');
      var n = name.toLowerCase();
      if (/colou?r|style|pattern|model|option|title/.test(n)) return val;
      if (/^[\d.,\/ -]+[a-z]{0,3}$/i.test(val) || String(val).length <= 3) return name.replace(/s$/i, '') + ' ' + val;
      return val;
    }).join(', ');
  }
  var shopName = (docBase.split(' | ').pop() || '').trim();
  function file(u) { if (!u) return ''; var s = String(u).split('?')[0]; return s.substring(s.lastIndexOf('/') + 1).replace(/_\d+x\d*(?=\.)/, ''); }

  /* gallery slides by image file name */
  var slides = Array.prototype.slice.call(document.querySelectorAll('[data-g-open]'));
  var slideFiles = slides.map(function (s) { return file(s.getAttribute('data-full')); });
  function slideFor(v) {
    var img = v && (v.featured_image || (v.featured_media && v.featured_media.preview_image));
    if (!img || !img.src) return -1;
    return slideFiles.indexOf(file(img.src));
  }
  function showSlide(i) {
    if (i < 0) return;
    var track = document.querySelector('[data-g-track]');
    /* jump straight there (no slide animation), then let the gallery update its thumbnails and counter */
    if (track) track.scrollTo({ left: i * track.clientWidth, behavior: 'auto' });
    var thumb = document.querySelector('[data-g-thumb="' + i + '"]');
    if (thumb) thumb.click();
  }

  /* v40: variant photo that is not in the gallery -> show it in the first slide (restored when a variant with its own slide is picked) */
  var first = slides[0], firstImg = first && first.querySelector('img'), orig = null;
  function srcOf(v) { var fi = v && v.featured_image; return fi ? (typeof fi === 'string' ? fi : fi.src) : ''; }
  function sized(u, w) { return /[?&]width=/.test(u) ? u.replace(/([?&])width=\d+/, '$1width=' + w) : u + (u.indexOf('?') > -1 ? '&' : '?') + 'width=' + w; }
  function restoreFirst() {
    if (!orig || !firstImg) return;
    firstImg.src = orig.src; if (orig.srcset) firstImg.setAttribute('srcset', orig.srcset); else firstImg.removeAttribute('srcset');
    first.setAttribute('data-full', orig.full);
    var th0 = document.querySelector('[data-g-thumb="0"] img'); if (th0 && orig.th) { th0.src = orig.th; if (orig.ths) th0.setAttribute('srcset', orig.ths); }
    orig = null;
  }
  function swapFirst(v) {
    var src = srcOf(v); if (!src || !firstImg) return false;
    var th = document.querySelector('[data-g-thumb="0"] img');
    if (!orig) orig = { src: firstImg.getAttribute('src'), srcset: firstImg.getAttribute('srcset'), full: first.getAttribute('data-full'), th: th && th.getAttribute('src'), ths: th && th.getAttribute('srcset') };
    firstImg.removeAttribute('srcset');
    firstImg.src = sized(src, 1200);
    first.setAttribute('data-full', sized(src, 2000));
    if (th) { th.removeAttribute('srcset'); th.src = sized(src, 200); }
    return true;
  }
  function showVariantImage(v) {
    var i = slideFor(v);
    if (i > -1) { restoreFirst(); showSlide(i); return; }
    if (swapFirst(v)) showSlide(0);
  }

  function setTitle(v) {
    var t = v ? base + ' – ' + vTitle(v) : base;
    if (h1) h1.textContent = t;
    if (sbTitle) sbTitle.textContent = t;
    if (crumb) crumb.textContent = t;
    document.title = shopName ? t + ' | ' + shopName : t;
  }

  document.addEventListener('aw:variant', function (e) {
    var v = e.detail;
    if (!v || !v.id) return;
    setTitle(v);
    showVariantImage(v);
  });

  /* ?variant= link: show the variant name in the heading from the start (the server already picked that variant) */
  try {
    var id = new URL(location.href).searchParams.get('variant');
    if (id) {
      for (var k = 0; k < product.variants.length; k++) if (String(product.variants[k].id) === id) { setTitle(product.variants[k]); showVariantImage(product.variants[k]); break; }
    }
  } catch (e) {}

  /* warm variant photos so a switch never waits on the network */
  function warm(i) {
    var s = slides[i]; if (!s) return;
    var img = s.querySelector('img');
    if (img && img.loading === 'lazy') { img.loading = 'eager'; if (img.decode) img.decode().catch(function () {}); }
  }
  var idle = window.requestIdleCallback || function (f) { return setTimeout(f, 1200); };
  window.addEventListener('load', function () {
    idle(function () { product.variants.forEach(function (v) { warm(slideFor(v)); }); });
  });
  box.addEventListener('pointerover', function (e) {
    var b = e.target.closest('[data-vp-val]'); if (!b) return;
    var o = b.closest('[data-vp-opt]'), oi = +o.getAttribute('data-vp-opt'), val = b.getAttribute('data-vp-val');
    for (var k = 0; k < product.variants.length; k++) if (product.variants[k].options[oi] === val) { warm(slideFor(product.variants[k])); break; }
  });
})();
